import {useEffect,useRef,useState} from 'react';
import {useAuth} from '../authContext';
import type {PhotoVideo} from './contracts';
import {fetchPhotoVideo} from './video';

export function usePhotoVideo(metadata:PhotoVideo|undefined,enabled=true){
 const {user,idToken,privileges}=useAuth(),[wake,setWake]=useState(0);
 const scope=JSON.stringify([user?.email,user?.status,user?.farm_ids,user?.roles,idToken,privileges,metadata?.assetId,metadata?.playbackPath,enabled,wake]);
 const current=useRef(scope);current.current=scope;
 const [state,setState]=useState<{scope:string;url?:string;error?:string}>({scope:''});
 const retry=()=>setWake(value=>value+1);
 useEffect(()=>{
  const reset=()=>setWake(value=>value+1);
  for(const event of ['online','offline','focus','sonata-photo-cache-purged'])window.addEventListener(event,reset);
  document.addEventListener('visibilitychange',reset);
  return()=>{for(const event of ['online','offline','focus','sonata-photo-cache-purged'])window.removeEventListener(event,reset);document.removeEventListener('visibilitychange',reset);};
 },[]);
 const available=enabled&&!!metadata?.playbackPath&&user?.status==='Active'&&!!idToken&&navigator.onLine&&document.visibilityState!=='hidden';
 useEffect(()=>{
  const abort=new AbortController();let url:string|undefined;setState({scope});
  if(available&&metadata)void fetchPhotoVideo(metadata,abort.signal).then(blob=>{
   if(abort.signal.aborted||current.current!==scope)return;
   url=URL.createObjectURL(blob);setState({scope,url});
  }).catch(()=>{if(!abort.signal.aborted&&current.current===scope)setState({scope,error:'Video unavailable. You can still view the photo.'});});
  return()=>{abort.abort();if(url)URL.revokeObjectURL(url);};
 },[scope,available,metadata?.byteLength]);
 const active=available&&state.scope===scope?state:undefined;
 return {video:active?.url&&metadata?.width&&metadata?.height?{src:active.url,type:'video/mp4',width:metadata.width,height:metadata.height}:undefined,
  loading:available&&!active?.url&&!active?.error,error:active?.error,retry};
}
